export default {"src":"/_next/static/media/global-exchange.84cdc67c.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};